import styled from 'styled-components';
import Icon from '@ant-design/icons';

export default styled(Icon)``;
